import { CloseRounded, PrintRounded } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
import React, { useContext } from "react";
import MinimalCloseRegAcc from "../../pos/closeRegister/MinimalCloseRegAcc";
import { Button } from "../../../controls";
import { PrintDiv } from "../../../hooks/Method";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";

const ViewClosingAccounts = ({ setViewAccounts, viewData }) => {
  const { t } = useTranslation();
  const { settings } = useContext(AppContext);

  const handlePrint = () => {
    PrintDiv("MinimalPrintReceipt");
    setViewAccounts(false);
  };

  return (
    <>
      <div className="tx-center d-flex j-between a-center p-5">
        <span className="fs-18 gray-color tx-upp border-left ml-5">
          {t("cashRegisterReport")}
        </span>
        <IconButton
          color="error"
          size="small"
          onClick={() => setViewAccounts(false)}
        >
          <CloseRounded />
        </IconButton>
      </div>
      <Divider />
      <MinimalCloseRegAcc {...{ values: viewData, settings }} />
      <div className="p-10 d-flex g-10">
        <Button
          startIcon={<PrintRounded />}
          onClick={handlePrint}
          variant="text"
          fullWidth
        >
          {t("print")}
        </Button>
      </div>
    </>
  );
};

export default ViewClosingAccounts;
